/**
 * Share parser — EXACT port of v2.9 shareOf_.
 *
 * Handles "70%" | "$750" | "remainder" and Google-Sheets-coerced values
 * ("70%" → 0.7, "$750" → 750). Bare numbers ≤ 1 are fractions of the total;
 * > 1 are flat dollars. The "Hannah 80bps" comp-code variant overrides a
 * flat-like share with loan × rate − fee (rate from config, default 0.008).
 * Pure module — shared with the frontend bundle.
 */

const { TAGS } = require('./tags');

function shareOf(spec, total, ctx, fee, config) {
  if (spec === null || spec === undefined || spec === '') return 0;
  // "Hannah 80bps" comp-code variant overrides her usual flat share.
  const flatLike = (typeof spec === 'number' && spec > 1) ||
    (typeof spec === 'string' && spec.trim().startsWith('$'));
  if (flatLike && ctx && TAGS.HANNAH_80BPS.test(ctx.compCode)) {
    const rate = (config && config.hannah_80bps_rate) || 0.008;
    return ctx.loan * rate - (fee || 0);
  }
  if (typeof spec === 'number') {
    return spec <= 1 ? total * spec : spec;
  }
  const s = String(spec).trim();
  if (/^remainder$/i.test(s)) return 0; // resolved by caller
  if (s.endsWith('%')) return total * (parseFloat(s) / 100);
  const n = parseFloat(s.replace(/[$,]/g, ''));
  if (isNaN(n)) return 0;
  return (s.startsWith('$') || n > 1) ? n : total * n;
}

module.exports = { shareOf };
